import { MenubarDesignTokens } from '@primeuix/themes/types/menubar';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tDeep } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/menubar/index.ts
const menu = componentCommon.menubar;
const menuDeep = tDeep(menu);

export const MenubarTelekomDT: MenubarDesignTokens = {
  root: {
    background: t(menu.background),
    borderColor: t(menu.border.color),
    borderRadius: t(menu.border.radius),
    color: t(menu.color),
    gap: t(menu.gap),
    padding: `${menuDeep.padding.y} ${menuDeep.padding.x}`,
  },
  baseItem: {
    borderRadius: t(menu.base.item.border.radius),
    padding: `${menuDeep.base.item.padding.y} ${menuDeep.base.item.padding.x}`,
  },
  item: {
    focusBackground: t(menu.item.focus.background),
    activeBackground: t(menu.item.active.background),
    color: t(menu.item.color),
    focusColor: t(menu.item.focus.color),
    activeColor: t(menu.item.active.color),
    padding: `${menuDeep.item.padding.y} ${menuDeep.item.padding.x}`,
    borderRadius: t(menu.item.border.radius),
    gap: t(menu.item.gap),
    icon: {
      color: t(menu.item.icon.color),
      focusColor: t(menu.item.icon.focus.color),
      activeColor: t(menu.item.icon.active.color),
    },
  },
  submenu: {
    gap: t(menu.submenu.gap),
    background: t(menu.submenu.background),
    borderColor: t(menu.submenu.border.color),
    borderRadius: t(menu.submenu.border.radius),
    padding: `${menuDeep.submenu.padding.y} ${menuDeep.submenu.padding.x}`,
    mobileIndent: t(menu.submenu.mobile.indent),
    icon: {
      size: t(menu.submenu.icon.size),
      color: t(menu.submenu.icon.color),
      focusColor: t(menu.submenu.icon.focus.color),
      activeColor: t(menu.submenu.icon.active.color),
    },
  },
  separator: {
    borderColor: t(menu.separator.border.color),
  },
  mobileButton: {
    borderRadius: t(menu.mobile.button.border.radius),
    size: t(menu.mobile.button.size),
    color: t(menu.mobile.button.color),
    hoverColor: t(menu.mobile.button.hover.color),
    hoverBackground: t(menu.mobile.button.hover.background),
    focusRing: {
      width: t(menu.mobile.button.focus.ring.width),
      color: t(menu.mobile.button.focus.ring.color),
      offset: t(menu.mobile.button.focus.ring.offset),
    },
  },
};
